import { useNavigate } from "react-router-dom"
import Cart from "../../icons/Cart"
import FlashOnIcon from "../../icons/FlashOnIcon"
import style from "./ProductCards.module.css"
const ProductCards = ({
  product,
  handelCart = () => {},
  handelBuy = () => {},
}) => {
  const navigate = useNavigate()
  const isOutOfStock = product?.stock == 0

  return product ? (
    <div className={style.card}>
      <div onClick={() => navigate(`/product/${product.id}`)}>
        {isOutOfStock && <span className={style.stockBadge}>Out of Stock</span>}
        {product.product_images?.[0] && (
          <img
            src={`${import.meta.env.VITE_BACKEND_URL}/public/images/products/${
              product.product_images[0].image_url
            }`}
            alt={product.name}
          />
        )}
      </div>

      <div>
        <span
          className={style.description}
          onClick={() => navigate(`/product/${product.id}`)}
        >
          {product.description}
        </span>
        <h2
          className={style.title}
          onClick={() => navigate(`/product/${product.id}`)}
        >
          {product.name}
        </h2>
        <strong
          className={style.price}
          onClick={() => navigate(`/product/${product.id}`)}
        >
          ₹
          {(
            parseFloat(product.rate) +
            (product.rate * parseFloat(product.product_category?.gst || 0)) / 100.0
          ).toFixed(2)}
        </strong>

        <div
          className={`${style.buttons} ${
            isOutOfStock ? style.disabled : ""
          }`}
        >
          <button
            type="button"
            className={style.cartBtn}
            onClick={handelCart}
            disabled={isOutOfStock}
          >
            Cart <Cart />
          </button>
          <button
            type="button"
            onClick={handelBuy}
            disabled={isOutOfStock}
          >
            Buy <FlashOnIcon />
          </button>
        </div>
      </div>
    </div>
  ) : null
}

export default ProductCards
